import React from "react";
import Lottie from "react-lottie";
import { useInView } from "react-intersection-observer";
import cl from "classnames";

const Card = ({ animation, title, description }) => {
  const { ref, inView, entry } = useInView({ threshold: 0.5 });
  const className = cl("card zoom-in", {
    "zoom-in-active": inView,
  });
  return (
    <>
      <div ref={ref} className={className}>
        <div className="image">
          <Lottie
            width={58}
            height={58}
            options={{
              animationData: animation,
            }}
          />
        </div>
        <h4 className="card-title">{title}</h4>
        <p className="card-description">{description}</p>
      </div>
    </>
  );
};

export default Card;
